import { Booking } from "../../types/booking";
import { parseTimeToHours } from "./calendarUtils";

export type SlotStatus = "available" | "booked" | "cleaning";

export interface BookingBlock {
  booking: Booking;
  startHour: number;
  endHour: number;
  isCleaning: boolean;
}

export function isSlotAvailable(
  roomId: string,
  slotStartHour: number,
  slotEndHour: number,
  todayStr: string,
  bookings: Booking[]
): SlotStatus {
  const roomBookings = bookings.filter(
    (b) => b.roomId === roomId || (b.roomId as { _id: string })?._id === roomId
  );
  let status: SlotStatus = "available";

  for (const b of roomBookings) {
    const bCheckInDate = b.checkInDate?.split("T")[0] || b.checkInDate;
    const bCheckOutDate = b.checkOutDate?.split("T")[0] || b.checkOutDate;
    const bInHour = parseTimeToHours(b.checkInTime);
    const bOutHour = parseTimeToHours(b.checkOutTime);

    let bookingStartHour: number | null = null;
    let bookingEndHour: number | null = null;
    let cleaningEndHour: number | null = null;

    if (bCheckInDate === todayStr && bCheckOutDate === todayStr) {
      bookingStartHour = bInHour;
      bookingEndHour = bOutHour;
      cleaningEndHour = bOutHour + 0.75; // 45 min
    } else if (bCheckInDate === todayStr) {
      bookingStartHour = bInHour;
      bookingEndHour = 24;
      cleaningEndHour = 24;
    } else if (bCheckOutDate === todayStr) {
      bookingStartHour = 0;
      bookingEndHour = bOutHour;
      cleaningEndHour = bOutHour + 0.75; // 45 min
    } else if (bCheckInDate < todayStr && bCheckOutDate > todayStr) {
      bookingStartHour = 0;
      bookingEndHour = 24;
      cleaningEndHour = 24;
    } else {
      continue;
    }

    if (bookingStartHour < slotEndHour && bookingEndHour > slotStartHour) {
      return "booked";
    }
    if (bookingEndHour <= slotStartHour && cleaningEndHour > slotStartHour && cleaningEndHour > bookingEndHour) {
      status = "cleaning";
    }
    if (bookingStartHour < slotEndHour && cleaningEndHour > slotStartHour && bookingEndHour <= slotStartHour) {
      status = "cleaning";
    }
  }
  return status;
}

export function getBookingBlocksForDay(dayStr: string, bookings: Booking[]): BookingBlock[] {
  const blocks: BookingBlock[] = [];
  for (const b of bookings) {
    const bCheckInDate = b.checkInDate?.split("T")[0] || b.checkInDate;
    const bCheckOutDate = b.checkOutDate?.split("T")[0] || b.checkOutDate;
    const bInHour = parseTimeToHours(b.checkInTime);
    const bOutHour = parseTimeToHours(b.checkOutTime);

    let startHour: number | null = null;
    let endHour: number | null = null;
    let addCleaning = false;

    if (bCheckInDate === dayStr && bCheckOutDate === dayStr) {
      startHour = bInHour;
      endHour = bOutHour;
      addCleaning = true;
    } else if (bCheckInDate === dayStr && bCheckOutDate > dayStr) {
      startHour = bInHour;
      endHour = 24;
    } else if (bCheckOutDate === dayStr && bCheckInDate < dayStr) {
      startHour = 0;
      endHour = bOutHour;
      addCleaning = true;
    } else if (bCheckInDate < dayStr && bCheckOutDate > dayStr) {
      startHour = 0;
      endHour = 24;
    } else {
      continue;
    }

    if (startHour !== null && endHour !== null) {
      blocks.push({ booking: b, startHour, endHour, isCleaning: false });
      if (addCleaning && endHour < 24) {
        blocks.push({
          booking: b,
          startHour: endHour,
          endHour: Math.min(endHour + 0.75, 24), // 45 min cleaning
          isCleaning: true,
        });
      }
    }
  }
  return blocks;
}
